import { ITweet } from "../../types/CommonTypes";
import { Tweet } from "react-twitter-widgets";
import "./Tweet.css";

const TweetCard = ({ id }: ITweet) => {
	return (
		<div className="tweet-card">
			<div className="tweet-card-inner">
				<Tweet tweetId={id} options={{ lang: "es" }} />
			</div>
		</div>
	);
};

export default TweetCard;
